import { EmptyValue } from "@bcc/components/ui";
import { formatDate } from "@client-shared/utils";
import { PurchaseOrderInvoice } from "@shared/types";
import { CellContext } from "@tanstack/react-table";

export const InvoiceDateCell = (props: CellContext<PurchaseOrderInvoice, unknown>) => {
  const invoiceStatus = props.row.original.invoiceStatus;
  if (invoiceStatus === "Unposted") {
    return (
      <div className="text-sm leading-snug">
        <EmptyValue />
      </div>
    );
  }
  return <div>{formatDate(props.getValue() as string)}</div>;
};
